import { createAction } from '@ngrx/store';

export const closeSamplesSSA = createAction(
    '[Samples/CloseSamples] Close samples page'
);
